<template>
  <div class="delegate common-calculator-content" ref="delegateCalc">
    <div class="common-calculator-title">Reward Calculator</div>
    <div class="common-calculator-subtitle">Delegator's blockreward calculator</div>
    <div class="common-calculator-title-line"></div>
    <a-form
      :layout="'vertical'"
    >
      <a-form-item label="Total current token supply" :validate-status="total === '0' ? 'error' : ''" :help="total === '0' ? ERRORNOZERO : ''">
        <a-input v-model="cpTotal" placeholder="Please enter Total current token supply" />
      </a-form-item>
      <a-form-item label="Annual inflation rate">
        <a-input v-model="cpInflation" suffix="%" placeholder="Please enter Annual inflation rate"/>
      </a-form-item>
      <a-form-item label="Block time (sec)" :validate-status="blockTime === '0' ? 'error' : ''" :help="blockTime === '0' ? ERRORNOZERO : ''">
        <a-input v-model="cpBlockTime" suffix="sec" placeholder="Please enter Block time (sec)"/>
      </a-form-item>
      <a-form-item label="Ecosystem & Community tax pool rate">
        <a-input v-model="cpContribution" suffix="%" placeholder="Please enter Ecosystem & Community tax pool rate"/>
      </a-form-item>
      <a-form-item label="Total staked(bonded) token ratio" >
        <a-input v-model="cpDelegateAccountedTotal" suffix="%" placeholder="Please enter Total staked(bonded) token ratio" />
      </a-form-item>
      <a-form-item label="Commission">
        <a-input v-model="cpCommission" suffix="%" placeholder="Please enter Commission"/>
      </a-form-item>
      <a-form-item label="Total number of staked token of the node" :validate-status="delegateAmount === '0' ? 'error' : ''" :help="delegateAmount === '0' ? ERRORNOZERO : ''">
        <a-input v-model="cpDelegateAmount" placeholder="Please enter Total number of staked token of the node"/>
      </a-form-item>
      <a-form-item label="Participation period (day)" :validate-status="rewardDate === '0' ? 'error' : ''" :help="rewardDate === '0' ? ERRORNOZERO : ''">
        <a-input v-model="cpRewardDate" suffix="day" placeholder="Please enter Participation period (day)"/>
      </a-form-item>
      <a-form-item label="Total delegated token" :validate-status="delegateNum === '0' ? 'error' : ''" :help="delegateNum === '0' ? ERRORNOZERO : ''">
        <a-input v-model="cpDelegateNum" placeholder="Please enter Total delegated token"/>
      </a-form-item>
    </a-form>
    <div class="common-calculator-row smallMode">
      <div class="common-calculator-row-item common-calculator-row-title">
        <div class="common-calculator-row-label">Annual return on blockreward</div>
      </div>
      <div class="common-calculator-row-item common-calculator-row-input">
        <div class="common-calculator-row-context">{{allYield}}</div>
      </div>
    </div>
    <div class="common-calculator-row smallMode">
      <div class="common-calculator-row-item common-calculator-row-title">
        <div class="common-calculator-row-label">Blockreward of delegator</div>
      </div>
      <div class="common-calculator-row-item common-calculator-row-input">
        <div class="common-calculator-row-context">{{delegateGetNum}}</div>
      </div>
    </div>
    <div class="common-calculator-row smallMode">
      <div class="common-calculator-row-item common-calculator-row-title">
        <div class="common-calculator-row-label">Contribution of ecosystem & community tax pool</div>
      </div>
      <div class="common-calculator-row-item common-calculator-row-input">
        <div class="common-calculator-row-context">{{reward}}</div>
      </div>
    </div>
    <!--<div class="common-calculator-line"></div>-->
    <!--<div class="common-calculator-note">{{'Annual increment of token ' + increase}}</div>-->
    <!--<div class="common-calculator-note">{{'Average blockreward  ' + oneBlockReward}}</div>-->
    <!--<div class="common-calculator-note">{{'Annual contribution of ecosystem & community tax pool  ' + oneYearCommunityReward}}</div>-->
    <!--<div class="common-calculator-note">{{'Return on every delegated token ' + rewardByOneToken}}</div>-->
    <!--<div class="common-calculator-line"></div>-->
    <!--<div class="common-calculator-info">*Formula of annual return on blockreward:  (Total current token supply * inflation rate)* (1- Ecosystem & Community tax pool rate) *[ Total number of staked token of the node / (total current token supply * total staked ratio)] * (1- commission)/ total number of staked token of the node</div>-->
    <!--<div class="common-calculator-info">*Formula of return of delegator: [ Total current token supply * inflation rate / (365.25 * 24 * 3600 /block time)]* (Participation period * 24 * 3600 /block time) * (1- Ecosystem & Community tax pool rate) * [Total number of staked token of the node / (Total current token supply * Total staked token ratio)] * (1- commission rate) / Total number of staked token of the node * Total delegated token</div>-->
    <!--<div class="common-calculator-info">*Formula of Ecosystem & Community tax pool: [ Total current token supply * annual inflation rate / (365.25 * 24 * 3600 /block time)] * (Participation period * 24 * 3600/ blocktime) * Ecosystem & Community tax pool rate</div>-->
    <!--<div class="common-calculator-info">*Formula of annual increment : Total current token supply * annual inflation rate</div>-->
    <!--<div class="common-calculator-info">*Formula of average blockreward: [Total current token supply * annual inflation rate / (365.25 * 24 *3600 /block time)]</div>-->
    <!--<div class="common-calculator-info">*Formula of Ecosystem & Community tax pool:Total current token supply * annual inflation rate  *Ecosystem & Community tax pool rate</div>-->
    <!--<div class="common-calculator-info">*Formula of return on every delegated token: [Total current token supply * inflation rate / (365.25 *24 *3600 /block time) * (1- commission rate) / Total number of staked token of the node</div>-->
  </div>
</template>

<script>
  import BN from "bignumber.js"
  import {tool} from "../js/mixin";

  export default {
    name: 'delegate',
    data () {
      return {
        total: '',                           // 当前发行总量
        inflation: '',                       // 年通货膨胀率
        blockTime: '',                       // 出块间隔
        contribution: '',                    // 用于生态和社区的比例
        // votingPower: '',
        delegateAccountedTotal: '',          // 所有委托总量占当前发行量比例
        commission: '',                      // 验证人收取佣金比例
        delegateAmount: '',                  // 验证人拥有的总委托金额
        rewardDate: '',                      // 收益计算时长
        delegateNum: '',                     // 委托数量
        ERRORNOZERO: 'Please enter non-zero numbers'
      }
    },
    components: {
    },
    mixins: [
      tool
    ],
    computed: {
      cpTotal: {
        get () {
          return this.total
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 18)
          this.total = null
          this.total = this.addThousandSeparator(myVal)
        }
      },
      cpInflation: {
        get () {
          return this.inflation
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 5)
          this.inflation = null
          this.inflation = this.addThousandSeparator(myVal)
        }
      },
      cpBlockTime: {
        get () {
          return this.blockTime
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 0)
          this.blockTime = null
          this.blockTime = this.addThousandSeparator(myVal)
        }
      },
      cpContribution: {
        get () {
          return this.contribution
        },
        set (val) {
          let myVal = this.onlyNumber(val, 5)
          myVal = this.smallTo(myVal, 100)
          this.contribution = null
          this.contribution = myVal
        }
      },
      // cpVotingPower: {
      //   get () {
      //     return this.votingPower
      //   },
      //   set (val) {
      //     let myVal = this.clearThousandSeparator(val)
      //     myVal = this.onlyNumber(myVal, 2)
      //     this.votingPower = null
      //     this.votingPower = this.addThousandSeparator(myVal)
      //   }
      // },
      cpDelegateAccountedTotal: {
        get () {
          return this.delegateAccountedTotal
        },
        set (val) {
          let myVal = this.onlyNumber(val, 5)
          myVal = this.smallTo(myVal, 100)
          this.delegateAccountedTotal = null
          this.delegateAccountedTotal = this.addThousandSeparator(myVal)
        }
      },
      cpCommission: {
        get () {
          return this.commission
        },
        set (val) {
          let myVal = this.onlyNumber(val, 5)
          myVal = this.smallTo(myVal, 100)
          this.commission = null
          this.commission = myVal
        }
      },
      cpDelegateAmount: {
        get () {
          return this.delegateAmount
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 18)
          this.delegateAmount = null
          this.delegateAmount = this.addThousandSeparator(myVal)
        }
      },
      cpRewardDate: {
        get () {
          return this.rewardDate
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 0)
          this.rewardDate = null
          this.rewardDate = this.addThousandSeparator(myVal)
        }
      },
      cpDelegateNum: {
        get () {
          return this.delegateNum
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 0)
          this.delegateNum = null
          this.delegateNum = this.addThousandSeparator(myVal)
        }
      },
      votingPower () {
        // 验证人拥有的总委托金额 / (当前发行总量 * 所有委托总量占当前发行量比例)
        if (this.total === '' || this.inflation === '') {
          return '--'
        }
        const res = new BN(this.clearThousandSeparator(this.delegateAmount))
          .div(new BN(this.clearThousandSeparator(this.total)).multipliedBy(new BN(this.delegateAccountedTotal).div(100)))
        return res
      },
      // 收益率
      allYield () {
        // (当前总发行量 * 通货膨胀率) * （1 - 社区贡献费）* 验证人的voting power * ( 1 - 验证人的当前佣金) / 验证人的当前委托资金
        // return (this.total * this.inflation) * (1 - this.contribution) * this.votingPower * (1 - this.commission) / this.delegateAmount
        const res = new BN(this.clearThousandSeparator(this.total))
          .multipliedBy(new BN(this.clearThousandSeparator(this.inflation)).div(100))
          .multipliedBy(new BN(1).minus(new BN(this.clearThousandSeparator(this.contribution)).div(100)))
          .multipliedBy(new BN(this.votingPower))
          .multipliedBy(new BN(1).minus(new BN(this.clearThousandSeparator(this.commission)).div(100)))
          .div(this.clearThousandSeparator(this.delegateAmount))
        if (isNaN(res)) {
          return '--'
        }
        return this.addThousandSeparator(res.multipliedBy(100).toFixed(2, 1)) + '%'
      },
      // n天总收益
      all () {
        // [发行总量 * 通货膨胀率 / (365 * 24 *3600 / 出块间隔)] * (duration *24 * 3600 / 出块间隔）
        const res = new BN(this.clearThousandSeparator(this.total))
          .multipliedBy(new BN(this.clearThousandSeparator(this.inflation)).div(100))
          .div(new BN(365).multipliedBy(24 * 60 * 60).div(this.clearThousandSeparator(this.blockTime)))
          .multipliedBy(new BN(this.clearThousandSeparator(this.rewardDate)).multipliedBy(24 * 60 * 60).div(this.clearThousandSeparator(this.blockTime)))
        return res
      },
      // 委托人将获得收益为
      delegateGetNum () {
        if (this.res === '--' || this.delegateNum === '') {
          return '--'
        }
        const res = new BN(this.clearThousandSeparator(this.delegateNum)).multipliedBy(this.res)
        return this.addThousandSeparator(res.toFixed(5, 1))
      },
      // 生态和社区将获得的奖励
      reward () {
        // all * 用于生态和社区的比例
        if (isNaN(this.all)) {
          return '--'
        }
        const res = this.all.multipliedBy(new BN(this.clearThousandSeparator(this.contribution)).div(100))
        return this.addThousandSeparator(res.toFixed(5, 1))
      },
      // 一年将增发数
      increase () {
        //  发行总量 * 通货膨胀率
        if (this.total === '' || this.inflation === '') {
          return '--'
        }
        const res = new BN(this.clearThousandSeparator(this.total))
          .multipliedBy(new BN(this.clearThousandSeparator(this.inflation)).div(100))
          .toFixed(5, 1)
        return this.addThousandSeparator(res)
      },
      // 平均一个块的奖励
      oneBlockReward () {
        // [发行总量 * 通货膨胀率 / (365 * 24 *3600 / 出块间隔)]
        if (this.total === '' || this.inflation === '' || this.blockTime === '') {
          return '--'
        }
        const res = new BN(this.clearThousandSeparator(this.total))
          .multipliedBy(new BN(this.clearThousandSeparator(this.inflation)).div(100))
          .div(new BN(365).multipliedBy(24 * 60 * 60).div(this.clearThousandSeparator(this.blockTime)))
        return this.addThousandSeparator(res.toFixed(5, 1))
      },
      // 生态社区一年将获得数
      oneYearCommunityReward () {
        // 发行总量 * 通货膨胀率 * 用于生态和社区的比例
        if (this.total === '' || this.inflation === '' || this.contribution === '') {
          return '--'
        }
        const res = new BN(this.clearThousandSeparator(this.total))
          .multipliedBy(new BN(this.clearThousandSeparator(this.inflation)).div(100))
          .multipliedBy(new BN(this.clearThousandSeparator(this.contribution)).div(100))
        return this.addThousandSeparator(res.toFixed(5, 1))
      },
      // 委托1token将获得的收益率
      res () {
        // all *（1 - 用于生态和社区的比例）* 验证人的voting power * ( 1 - 佣金比例) / 总委托金额
        if (isNaN(this.all)) {
          return '--'
        }
        const res = this.all
          .multipliedBy(new BN(1).minus(new BN(this.clearThousandSeparator(this.contribution)).div(100)))
          .multipliedBy(new BN(this.votingPower))
          .multipliedBy(new BN(1).minus(new BN(this.clearThousandSeparator(this.commission)).div(100)))
          .div(this.clearThousandSeparator(this.delegateAmount))
        return res
      },
      // 委托1token将获得的收益
      rewardByOneToken () {
        if (this.res === '--') {
          return '--'
        }
        return this.addThousandSeparator(this.res.toFixed(5, 1))
      }
    },
    methods: {
    },
    mounted () {
    },
    beforeDestroy () {
    }
  }
</script>

<style scoped>

</style>